import { InteractionEventType, } from '@debbie/common/dist/interactions/events/index.js';
import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import THEME from '../../../../theme.js';
import Alert from '../../../Alert.js';
import Col from '../../../Grid/Col.js';
import Row from '../../../Grid/Row.js';
import Shield from '../../../Icons/Shield.js';
import XCircle from '../../../Icons/XCircle.js';
import Well from '../../../Well.js';
import { Box } from '../Helpers.js';
import CommonEvent from './CommonEvents.js';
const LetterEventCmp = (props) => {
    switch (props.event.type) {
        case InteractionEventType.Failed:
            return React.createElement(FailedEvent, { event: props.event });
        case InteractionEventType.TransferredToPrintAndDistribution:
            return React.createElement(TransferredToPrintAndDistributionEventCmp, { event: props.event });
        default:
            return React.createElement(CommonEvent, { event: props.event });
    }
};
const FailedEvent = (props) => {
    const { event } = props;
    const lang = useSelector((s) => s.lang);
    if (event.type !== InteractionEventType.Failed) {
        throw 'Invalid event type';
    }
    return (React.createElement(Well, { style: { marginBottom: `${THEME.GRID_SPACING}px` } },
        React.createElement(Row, null,
            React.createElement(Col, { width: "12" },
                React.createElement("h3", { style: { color: THEME.COLOR_ACCENT } },
                    React.createElement(XCircle, { style: {
                            margin: '0.15em 0 -0.15em',
                        } }),
                    ' ',
                    lang.interactions.letterReturned),
                React.createElement(Alert, { size: "small", style: {
                        backgroundColor: THEME.COLOR_SECONDARY,
                        color: THEME.COLOR_ACCENT,
                    }, message: `Event id: ${event.id}` }))),
        React.createElement(Row, null,
            React.createElement(Box, { header: lang.interactions.failedAt, body: React.createElement(React.Fragment, null,
                    React.createElement(Shield, { style: {
                            margin: '0.15em 0 -0.15em',
                            color: THEME.COLOR_ACCENT,
                        } }),
                    ' ',
                    moment(event.createdAt).format(THEME.DATE_FORMAT_LONG)) }),
            React.createElement(Box, { header: lang.interactions.reason, body: (event.data.returnReason &&
                    lang.returnLetterReasons[event.data.returnReason]) ||
                    'N/A' }))));
};
const TransferredToPrintAndDistributionEventCmp = (props) => {
    const { event } = props;
    const lang = useSelector((s) => s.lang);
    return (React.createElement(Well, { style: { marginBottom: `${THEME.GRID_SPACING}px` } },
        React.createElement(Row, null,
            React.createElement(Box, { header: lang.interactionEventTypes[InteractionEventType.TransferredToPrintAndDistribution], body: React.createElement(React.Fragment, null,
                    React.createElement(Shield, { style: {
                            margin: '0.15em 0 -0.15em',
                            color: THEME.COLOR_ACCENT,
                        } }),
                    ' ',
                    moment(event.createdAt).format(THEME.DATE_FORMAT_LONG)) }))));
};
export default LetterEventCmp;
//# sourceMappingURL=Letter.js.map